import React, { useState } from "react"
import TextField from "@material-ui/core/TextField"
import MenuItem from "@material-ui/core/MenuItem"
import { makeStyles } from "@material-ui/core/styles"
import { IOptionNormalized } from "../../../options/interfaces/options-normalized"
import { Autocomplete } from "@material-ui/lab"
import { useTranslations } from "./useTranslations"

const useStyles = makeStyles((theme) => ({
  menuPaper: {
    maxHeight: 400,
  },
}))

const SearchAndSelectMenu = (props: Props) => {
  const translations = useTranslations()
  const { label, options, onSelect, value } = props
  const classes = useStyles()
  const [selectedOption, setSelectedOption] = useState<IOptionNormalized | null>(value)

  const handleSelect = (option: IOptionNormalized | null) => {
    setSelectedOption(option)
    onSelect(option)
  }

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option.name}
      value={selectedOption}
      onChange={(event, newValue) => handleSelect(newValue)}
      renderInput={(params) => <TextField {...params} label={label} variant="outlined" />}
      classes={{ paper: classes.menuPaper }}
      noOptionsText={translations.noData}
      renderOption={(option) => (
        <MenuItem key={option.id} value={option.id}>
          {option.name}
        </MenuItem>
      )}
    />
  )
}

type Props = {
  label: string
  value: IOptionNormalized | null
  options: IOptionNormalized[]
  onSelect: (selected: IOptionNormalized | null) => void
}

export default SearchAndSelectMenu
